import { Component, inject, Input, OnInit } from '@angular/core';
import { HeaderConfigurationComponent } from '../../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import { IonButton, IonContent } from '@ionic/angular/standalone';
import { LabelConfigurationComponent } from '../../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { LabelDescriptionComponent } from '../../../../../../../../components/ecosystems/label-description/label-description.component';
import { LargedLinkComponent } from '../../../../../../../../components/ecosystems/larged-link/larged-link.component';
import { MinuterieLabelComponent } from '../../../../../../../../components/ecosystems/minuterie-label/minuterie-label.component';
import { TranslatePipe } from '@ngx-translate/core';
import { TwoChoicesControlComponent } from '../../../../../../../../components/ecosystems/two-choices-control/two-choices-control.component';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import { SlideModalController } from '../../../../../../../slide-modal.service';
import {
  Pool,
  PoolAdditionalData,
} from '../../../../../../../../apis/pool.api';
import { IProduct } from '../../../../../IProduct';
import { getPoolMasterClass } from '../../../../../../ECoSystemsHelper';
import { P00030 } from '../../../../P00030';
import { P00032 } from '../../../../P00032';
import { P0003600EnSavoirPlusComponent } from '../../../../P0003600/Filtration/enSavoirPlus/p0003600-en-savoir-plus/p0003600-en-savoir-plus.component';
import { FunctionParametersSettingsClockScreenComponent } from '../../../../../../../../components/ecosystems/function-parameters-settings-clock-screen/function-parameters-settings-clock-screen.component';
import { FunctionParametersSettingClockWeekScreenComponent } from '../../../../../../../../components/ecosystems/function-parameters-setting-clock-week-screen/function-parameters-setting-clock-week-screen.component';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { P0003601EnSavoirPlusComponent } from '../../../EnSavoirPlus/p0003601-en-savoir-plus/p0003601-en-savoir-plus.component';
import { P0003601ProgrammeFiltrationAuto } from '../../../Enum/P0003601ProgrammeFiltrationAuto';
import { FunctionParametersSettingClockWeekVSScreenComponent } from '../../../Component/function-parameters-setting-clock-week-vsscreen/function-parameters-setting-clock-week-vsscreen.component';
import { FunctionParametersSettingClockVSScreenComponent } from '../../../Component/function-parameters-setting-clock-vsscreen/function-parameters-setting-clock-vsscreen.component';

@Component({
  selector: 'app-p0003601-filtration-mise-en-oeuvre-programme',
  templateUrl: './p0003601-filtration-mise-en-oeuvre-programme.component.html',
  styleUrls: ['./p0003601-filtration-mise-en-oeuvre-programme.component.scss'],
  imports: [
    HeaderConfigurationComponent,
    IonButton,
    IonContent,
    LabelConfigurationComponent,
    LabelDescriptionComponent,
    LargedLinkComponent,
    MinuterieLabelComponent,
    TranslatePipe,
    TwoChoicesControlComponent,
  ],
})
export class P0003601FiltrationMiseEnOeuvreProgrammeComponent
  implements OnInit
{
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  private slideModalService: SlideModalController =
    inject(SlideModalController);
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  @Input() pool: Pool | null = null;

  constructor() {
    this.openEnSavoirPlus = this.openEnSavoirPlus.bind(this);
  }

  async openEnSavoirPlus() {
    const modal = await this.slideModalService.create({
      component: P0003601EnSavoirPlusComponent,
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );
  }

  async goToFunctionParametersSettingsClockScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingClockWeekVSScreenComponent,
      componentProps: {
        value: this.actionStack!.getValue('fvsPHorlogeVitesseSemainePPH'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;

      this.actionStack!.editValue(
        P00039DataRxTxIndex.FiltrationVS_Parametrage2,
        'fvsPHorlogeVitesseSemainePPH',
        hj,
        null,
      );
    }
  }

  async goToFunctionParametersSettingClockWeekScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingClockVSScreenComponent,
      componentProps: {
        value:
          this.actionStack!.getValue('fvsPHorlogeVitesseJoursPPHA') +
          this.actionStack!.getValue('fvsPHorlogeVitesseJoursPPHB'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;
      this.actionStack!.editValue(
        P00039DataRxTxIndex.FiltrationVS_Parametrage,
        'fvsPHorlogeVitesseJoursPPHA',
        hj.substring(0, 120),
        null,
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.FiltrationVS_Parametrage2,
        'fvsPHorlogeVitesseJoursPPHB',
        hj.substring(120),
        null,
      );
    }
  }

  async goToFunctionParametersSettingsClockPPEScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingClockVSScreenComponent,
      componentProps: {
        value:
          this.actionStack!.getValue('fvsPHorlogeVitesseJoursPPEA') +
          this.actionStack!.getValue('fvsPHorlogeVitesseJoursPPEB'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;

      this.actionStack!.editValue(
        P00039DataRxTxIndex.FiltrationVS_Parametrage3,
        'fvsPHorlogeVitesseJoursPPEA',
        hj.substring(0, 120),
        null,
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.FiltrationVS_Parametrage4,
        'fvsPHorlogeVitesseJoursPPEB',
        hj.substring(120),
        null,
      );
    }
  }

  async goToFunctionParametersSettingClockWeekPPEScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingClockWeekVSScreenComponent,
      componentProps: {
        value: this.actionStack!.getValue('fvsPHorlogeVitesseSemainePPE'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;
      this.actionStack!.editValue(
        P00039DataRxTxIndex.FiltrationVS_Parametrage4,
        'fvsPHorlogeVitesseSemainePPE',
        hj,
        null,
      );
    }
  }

  onSubmit() {
    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P0003601ProgrammeFiltrationAuto =
    P0003601ProgrammeFiltrationAuto;
}
